import Claim from './Claim';

export default Claim;
